export enum MeasurementEnum {
  GRAM = 'Gram',
  MILLILITER = 'Milliliter',
  UNIT = 'Unit',
  KILOGRAM = 'Kilogram',
  NONE = 'None',
}

export type MeasurementType = EnumValueType<typeof MeasurementEnum>;

/**
 * TODO: This interface contains fields with duplicated meaning under different names (e.g. dishName/name,
 *  dishDescription/description, dishPrice/price), as it is shared across multiple API responses
 *  (/Menu, /GetReOrderMenuItems, etc.). This should be refactored by splitting the interface per API response
 *  and introducing dedicated mappers at the API layer to normalize the data into a unified model.
 *  Ensure all consumers of this interface and the affected API methods are updated accordingly.
 */
export default interface Dish {
  id: number;
  dishId: number | string;
  dishName: string;
  dishDescription: string;
  dishPrice: number;
  price: number;
  categoryId: number;
  choices: DishChoice[];
  dishImageUrl: string;
  isPopularDish: boolean;
  dishPopularityScore: number;
  enableComment: boolean;
  resId: number;
  shoppingCartDishId: number;
  quantity?: number;
  ageRestricted: boolean;
  restrictionAge: string;
  name: string;
  description: string;
  pricePerMeasurementUnit?: number;
  measurementUnitScale?: number;
  measurementUnit?: MeasurementType;
  hasHighSugar: boolean;
  hasHighSaturatedFat: boolean;
  hasHighSodium: boolean;
  alcoholPercentage: number;
}

export interface DishChoice {
  choiceId: number;
  isForced: boolean;
  textBeforeChoosing: string;
  maxPicksAllowed: number;
  subs: DishChoiceSub[];
  subsChosen?: DishChoiceSub[];
}

export interface DishChoiceSub {
  subId: number;
  price: number;
  name: string;
  catalogId: string;
  ageRestricted: boolean;
  restrictionAge: string;
}
